import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotFoundState {
    triggerKey: string | null;
}

const initialState: NotFoundState = { triggerKey: null };

const notFoundSlice = createSlice({
    name: 'notFound',
    initialState,
    reducers: {
        triggerNotFound(state, action: PayloadAction<string>) {
            state.triggerKey = action.payload;
        },
        clearNotFound(state) {
            state.triggerKey = null;
        },
    },
});

export const { triggerNotFound, clearNotFound } = notFoundSlice.actions;
export default notFoundSlice.reducer;
